
import React from 'react'

import { getErrorMessage } from 'utils'

import type { Company } from 'types'

import { useSnackbar } from 'contexts'
import { useCompanyMutationsQuery } from 'hooks/api'

import { Stack, Typography } from '@mui/material'

import { Button, Modal } from '@repo/ui'

import { CompanyPreview } from 'components'

interface DeleteCompanyModalProps {
  company: Company | null
  open: boolean
  onClose: () => void
  refetch: () => void
}

export const DeleteCompanyModal = (props: DeleteCompanyModalProps) => {
  const { company, open, onClose = () => {}, refetch } = props

  const { open: notification } = useSnackbar()

  const { remove, isLoading } = useCompanyMutationsQuery({
    onSuccess: () => {
      onClose()
      refetch()
    },
    onError: error => {
      const message = getErrorMessage(error)
      notification({
        type: 'error',
        title: message,
      })
    },
  })

  const handleClose = () => {
    onClose()
  }

  const handleConfirm = () => {
    remove({ id: company?.id as string })
  }

  return (
    <Modal
      title="Archive company"
      open={open}
      onClose={handleClose}
      actions={
        <>
        <Button
          variant="secondary"
          onClick={() => handleClose()}
          disabled={isLoading}
        >
          Cancel
        </Button>

        <Button
          onClick={() => handleConfirm()}
          destructive
          disabled={isLoading}
        >
          {isLoading ? 'Archiving...' : 'Archive'}
        </Button>
      </>
      }
    >
      <Stack spacing={4}>
        <Typography variant="body2" color="text.secondary">Are you sure you want to archive the following company? This will set their status to inactive.</Typography>
        <CompanyPreview company={company} />
      </Stack>
    </Modal>
  )
}
